import { CelebrationLoading } from "@components/adapters/celebration/Loading";
import type { LoadingProps } from "@components/contracts/Loading.types";

export const Loading: React.FC<LoadingProps> = (props) => (
  <CelebrationLoading {...props} />
);

export type { LoadingProps };
